import { AfterViewInit, Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import Inputmask from 'inputmask';
import { IRelatoriaModel } from 'src/app/models/relatoria.model';
import { IRelatoriaCapituloModel } from 'src/app/models/relatoria-capitulo.model';
import { IHistoricoRelatoriaCapituloModel } from 'src/app/models/historico-relatoria-capitulo.model';

@Component({
  selector: 'app-modal-visualizar-historico',
  templateUrl: './modal-visualizar-historico.component.html',
  styleUrls: ['./modal-visualizar-historico.component.scss'],
})

export class ModalVisualizarHistoricoComponent
  implements OnInit, AfterViewInit {
  [x: string]: any;
  public historico: IHistoricoRelatoriaCapituloModel = {} as IHistoricoRelatoriaCapituloModel;
  public modelRelatoria: IRelatoriaModel = {} as IRelatoriaModel;
  public model: IRelatoriaCapituloModel = {} as IRelatoriaCapituloModel;
  differences: any[] = [];
  public removidoConteudo: string;
  public removidoNome: string;
  public adicionadoConteudo: string;
  public adicionadoNome: string;
  public semAlteracao: string;
  public textoDestacado: string = '';
  public textoRemovido: string = '';
  public dataFormatada: string = '';

  constructor(
    private dialogRef: MatDialogRef<ModalVisualizarHistoricoComponent>,
    public matDialog: MatDialog,

    @Inject(MAT_DIALOG_DATA) public data) {
    this.historico = data.historico;
  }

  ngOnInit(): void {

    const textoAnterior = this.limparHtml(this.historico.conteudoAnterior);
    const textoAtual = this.limparHtml(this.historico.conteudoAtual);

    const minLength = Math.min(textoAnterior.length, textoAtual.length);

    let diffStartIndex = 0;
    while (
      diffStartIndex < minLength &&
      textoAnterior[diffStartIndex] === textoAtual[diffStartIndex]
    ) {
      diffStartIndex++;
    }

    let diffEndIndex = 0;
    while (
      diffEndIndex < minLength - diffStartIndex &&
      textoAnterior[textoAnterior.length - diffEndIndex - 1] ===
      textoAtual[textoAtual.length - diffEndIndex - 1]
    ) {
      diffEndIndex++;
    }

    this.removidoConteudo = textoAnterior.substring(
      diffStartIndex,
      textoAnterior.length - diffEndIndex
    );

    this.adicionadoConteudo = textoAtual.substring(
      diffStartIndex,
      textoAtual.length - diffEndIndex
    );

    this.semAlteracao =
      textoAtual.substring(0, diffStartIndex) +
      this.adicionadoConteudo +
      textoAtual.substring(textoAtual.length - diffEndIndex);

    const nomeAnterior = this.limparHtml(this.historico.nomeAnterior || '');
    const nomeAtual = this.limparHtml(this.historico.nomeAtual || '');

    const minLengthNome = Math.min(nomeAnterior.length, nomeAtual.length);

    let diffStartIndexNome = 0;
    while (
      diffStartIndexNome < minLengthNome &&
      nomeAnterior[diffStartIndexNome] === nomeAtual[diffStartIndexNome]
    ) {
      diffStartIndexNome++;
    }

    let diffEndIndexNome = 0;
    while (
      diffEndIndexNome < minLengthNome - diffStartIndexNome &&
      nomeAnterior[nomeAnterior.length - diffEndIndexNome - 1] ===
      nomeAtual[nomeAtual.length - diffEndIndexNome - 1]
    ) {
      diffEndIndexNome++;
    }

    this.removidoNome = nomeAnterior.substring(
      diffStartIndexNome,
      nomeAnterior.length - diffEndIndexNome
    );

    this.adicionadoNome = nomeAtual.substring(
      diffStartIndexNome,
      nomeAtual.length - diffEndIndexNome
    );

    this.dataFormatada = this.getFormattedDate(this.historico.dataAlteracao);
  }

  destacarAlteracoes() {
    let diffOutput = '';
    let startIndex = 0;

    for (let i = 0; i < this.historico.conteudoAnterior.length; i++) {
      if (this.historico.conteudoAnterior[i] !== this.historico.conteudoAtual[i]) {
        diffOutput += `<span>${this.historico.conteudoAnterior.substring(startIndex, i)}</span>`;
        diffOutput += `<span class="destaqueTexto" style="color: blue !important; font-weight: bold !important;">${this.historico.conteudoAtual.substring(i, i + 1)}</span>`;
        startIndex = i + 1;
      }
    }

    diffOutput += `<span>${this.historico.conteudoAnterior.substring(startIndex)}</span>`;

    this.textoDestacado = diffOutput != '' ? diffOutput : this.historico.conteudoAtual;
  }

  identificarRemocoes() {
    let removido = this.diffString(this.historico.conteudoAnterior, this.historico.conteudoAtual);
    this.textoRemovido = this.realcarRemocoes(removido);
  }

  private limparHtml(html: string): string {
    if (!html) return '';

    html = html
      .replace(/<br\s*\/?>/gi, '\n')
      .replace(/<\/p>/gi, '\n')
      .replace(/<p[^>]*>/gi, '')
      .replace(/&nbsp;/gi, ' ');

    const div = document.createElement('div');
    div.innerHTML = html;

    return (div.textContent || '')
      .replace(/\n{3,}/g, '\n\n')
      .trim();
  }

  diffString(textoOriginal: string, textoAtual: string): string {
    let diffOutput = '';
    for (let i = 0; i < textoOriginal.length; i++) {
      if (textoOriginal[i] !== textoAtual[i]) {
        diffOutput += textoOriginal[i];
      }
    }
    return diffOutput;
  }

  realcarRemocoes(textoRemovido: string): string {
    return this.historico.conteudoAnterior.replace(
      new RegExp(`(${textoRemovido})`, 'g'),
      '<span "style=text-decoration: line-through;">$1</span>'
    );
  }

  ngAfterViewInit(): void {
    Inputmask().mask(document.querySelectorAll('input'));
    this.destacarAlteracoes();
    this.identificarRemocoes();
  }

  public getFormattedDate(data) {
    var date = new Date(data);
    var day = date.getDate();
    var month = date.getMonth() + 1;
    var year = date.getFullYear();
    var hour = date.getHours();
    var minutes = date.getMinutes();
    return day + '/' + month + '/' + year + ' às ' + hour + ':' + minutes;
  }

  public fechar() {
    this.dialogRef.close();
  }
}
